const client = {
    clientId: '6FAsB0XmorbnVDYl1IvwMjduM9EX91',
    clientSecret: 'Nl3RhbTk2hJkxth0vbjqJidf0UbUjjOBjUw1xbK9RHkBrBDOo0YeL4SZGis'
};

export const ClientEncoded = window.btoa(client.clientId + ':' + client.clientSecret);
